import 'object_entries';
import 'idempotent-babel-polyfill';
import { ExperienceTempPage } from './ExperienceTempPage';

declare const global: any;

// These Components need to be global for ReactJS.net to use them
global.ExperienceTempPage = ExperienceTempPage;
